import { isAxiosError } from "axios";
import { Action } from "redux";
import {
  AuthenticatedUser,
  LoginForm,
  ServerError,
  ThunkAction,
  User,
} from "../types/index.js";
import { copiedModuleClipboard, fetch } from "../utils/utils.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = [
  "POST_LOGIN_START",
  "POST_LOGIN_SUCCESS",
  "POST_LOGIN_ERROR",
] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type PostLoginStart = ActionBase<"POST_LOGIN_START">;
type PostLoginSuccess = ActionBase<"POST_LOGIN_SUCCESS"> & { user: User };
type PostLoginError = ActionBase<"POST_LOGIN_ERROR"> & { error: ServerError };

export type LoginAction = PostLoginStart | PostLoginSuccess | PostLoginError;

export const isLoginAction = (action: Action): action is LoginAction =>
  isActionType(action, ActionTypeKeys);

export const postLogin =
  (form: LoginForm): ThunkAction<Promise<void>> =>
  async (dispatch) => {
    dispatch(postLoginStart());
    try {
      const { data: user } = await fetch({ dispatch }).post<AuthenticatedUser>(
        "users/login",
        form,
      );
      window.localStorage.setItem("user", JSON.stringify(user));

      copiedModuleClipboard.clear();

      dispatch(postLoginSuccess(user));
    } catch (error) {
      isAxiosError<ServerError>(error) &&
        error.response &&
        dispatch(postLoginError(error.response.data));
      throw error;
    }
  };

const postLoginStart = (): PostLoginStart => ({ type: "POST_LOGIN_START" });

const postLoginSuccess = (user: AuthenticatedUser): PostLoginSuccess => ({
  type: "POST_LOGIN_SUCCESS",
  user,
});

const postLoginError = (error: ServerError): PostLoginError => ({
  type: "POST_LOGIN_ERROR",
  error,
});
